import { MENU_ITEMS } from '@/constants/menu';
import { Logo } from './logo';
import { Navigation } from './navigation';
import { ActionButtons } from './action-buttons';
import SubNavItem from './subnav-item';
import { ActionMenuItem, ExpandableMenuItem } from '@/types/menu';
import { useState } from 'react';
import ProductHeader from './product-header';
import { ProductHeaderData } from '@/types/product-pages';
import clsx from 'clsx';
import Link from 'next/link';

interface HeaderProps {
  type: 'voce' | 'suaempresa' | 'home';
  data: ProductHeaderData | null;
}

const productConfig = {
  ALIMENTACAO: 'CAIXA Alimentação',
  TAGCAIXA: 'tagCAIXA',
  REFEICAO: 'CAIXA Refeição',
  MULTI: 'CAIXA Multi',
  VTCAIXA: 'vtCAIXA',
  FROTACAIXA: 'frotaCAIXA',
  DESPESACAIXA: 'DESPESA CAIXA',
};

export function DesktopHeader({ type, data }: HeaderProps) {
  const [itemClicked, setItemClicked] = useState(-1);

  const productActions: ActionMenuItem[] = [
    {
      label: 'JÁ SOU CLIENTE',
      href: data?.clienteHref,
      variant: 'ghost',
      className:
        'rounded-[8px] border border-white px-[22px] text-xs font-bold uppercase tracking-[0.06em] text-white hover:bg-white/10',
    },
    {
      label: 'ADQUIRA JÁ',
      href: data?.adquiraHref,
      variant: 'secondary',
      className:
        'rounded-[8px] px-[22px] text-xs font-bold uppercase tracking-[0.06em] text-white hover:bg-secondary-hover',
    },
  ];

  const height = type == 'home' ? 20 : 14;

  return (
    <div className={`hidden fixed w-full z-50 lg:block`}>
      <div
        className={clsx(
          type === 'home' ? 'h-20' : 'h-14',
          'bg-bluecaixa overflow-hidden'
        )}
      >
        <div className="flex container mx-auto h-full items-center justify-between py-4 gap-7 max-w-7xl px-6 xl:px-0">
          <div className="flex items-center gap-8">
            <Logo variant="default" />
            <Navigation
              onOpenSub={(i: number) => {
                if (itemClicked == -1) setItemClicked(i);
              }}
              selected={itemClicked}
              items={MENU_ITEMS.main}
              className="flex items-center gap-[26px]"
            />
          </div>
          {type === 'home' && data === null && (
            <ActionButtons items={productActions} />
          )}
        </div>
      </div>
      {itemClicked != -1 && (
        <SubNavItem
          top={height}
          onHide={() => {
            setItemClicked(-1);
          }}
          menuData={MENU_ITEMS.main[itemClicked] as ExpandableMenuItem}
        />
      )}

      {/* Submenus */}
      {data !== null && <ProductHeader data={data} actions={productActions} />}
      {type != 'home' && (
        <nav
          aria-label="Trilha de navegação"
          className="w-full border-b border-[#E8EEF4] bg-white"
        >
          <ol className="flex container py-2 px-6 xl:px-0 flex-wrap mx-auto items-center gap-2 text-primary text-xs font-semibold max-w-7xl">
            <li>
              <Link
                href="/"
                className="transition-colors hover:text-orangecaixa"
              >
                PÁGINA PRINCIPAL
              </Link>
            </li>
            <li className="flex items-center gap-2">
              <span aria-hidden className="text-[#9FB4C8]">
                /
              </span>
              <span>{type == 'voce' ? 'PARA VOCÊ' : 'PARA SUA EMPRESA'}</span>
            </li>
            <li className="flex items-center gap-2">
              <span aria-hidden className="text-[#9FB4C8]">
                /
              </span>
              <span aria-current="page" className="text-orangecaixa">
                {data?.nome
                  ? productConfig[data.nome as keyof typeof productConfig]
                  : ''}
              </span>
            </li>
          </ol>
        </nav>
      )}
    </div>
  );
}
